<template>
  <div class="table-ticker">
    <div v-if="showCountryFlag" class="mr-1">
      <CountryFlag
        :country="position.country"
        :legalCountry="position.legalCountry"
        :exchange="position.exchange"
        :exposureCountry="position.exposureCountry"
        :type="position.type"
        :width="18"
      />
    </div>

    <a
      :class="{
        'secondary--text': !$vuetify.theme.dark && isLinkedTicker,
        'not-linked-ticker black--text':
          !$vuetify.theme.dark && (position.pendingRecreate || !isLinkedTicker),
        'white--text': $vuetify.theme.dark,
      }"
      @click="tickerClicked()"
    >
      <template
        v-if="
          showAlwaysTicker ||
          ['stock', 'right', 'etf', 'putOption', 'callOption', 'index'].indexOf(type) > -1
        "
      >
        {{ shorten(position.ticker) }}
      </template>
      <template v-else-if="['fund', 'plan', 'bond'].indexOf(type) > -1">
        <div>
          <span v-if="position.name">{{ shorten(position.name) }}</span>
          <span v-else>
            {{ shorten(position.ticker) }}
          </span>
        </div>
      </template>
      <template v-else-if="['crypto', 'commodity'].indexOf(type) > -1">
        <div class="ml-1">
          {{ shorten(position.ticker) }}
        </div>
      </template>
      <template v-else-if="['cash'].indexOf(type) > -1">
        <div class="margin-left-cash">
          {{ shorten(position.ticker) }}
        </div>
      </template>
      <template v-else>
        {{ shorten(position.ticker) }}
      </template>
    </a>

    <span
      v-if="!user.preferences || (user.preferences && user.preferences.defaultShowTypeTableTicker)"
      class="table-ticker-position-type"
    >
      {{ $t(`common.positionTypesAbbrev.${position.type}`) }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CountryFlag from '@/views/components/common/CountryFlag'
import { shortenText } from '@/lib/utils/utils.js'
import { getPositionOrDerivativePositionType } from '@/lib/positions/positions.js'

export default {
  components: {
    CountryFlag,
  },
  props: {
    position: {
      type: Object,
      default: null,
    },
    showCountryFlag: {
      type: Boolean,
      default: true,
    },
    showAlwaysTicker: {
      type: Boolean,
      default: false,
    },
    notLinkToDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['user']),
    type() {
      return getPositionOrDerivativePositionType(this.position)
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    isLinkedTicker() {
      return this.notLinkToDetail || (this.$route && this.$route.name !== 'dashboardDetail')
    },
  },
  methods: {
    shorten(name) {
      if (this.isMobile) return shortenText(name, 7)
      return shortenText(name, 15)
    },
    tickerClicked() {
      if (this.position.pendingRecreate) return
      if (this.notLinkToDetail) {
        this.$emit('tickerClicked')
      } else {
        if (this.$route && this.$route.name !== 'portfolio') {
          this.$router.replace({
            name: 'portfolio',
            query: { position: this.position._id },
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
.table-ticker {
  display: flex;
  font-weight: 500;
  align-items: center;
  img {
    margin-top: 5px;
    margin-right: 5px;
  }
  a {
    text-decoration: none;
  }
  .table-ticker-position-type {
    font-size: 9px;
    color: #999;
    margin-left: 2px;
    margin-top: 6px;
  }
  .margin-left-cash {
    margin-left: 5px;
  }
}
</style>
